<template>
  <div class="main-container" v-if="formData">
    <div class="info-box" v-if="formData.status == 0">转介人、申请人、产品名称、投保人姓名（中文）及其联系电话填写后即可保存</div>
    <Form ref="myForm" :model="formData" :label-width="130" class="page-form" :disabled="disabled" :show-message="!disabled">
      <FormItem label="预约编号" v-if="formData.reservationNo">
        {{ formData.reservationNo }}
      </FormItem>
      <FormItem :label="isIFA ? '归属团队' : '转介人'" prop="tenantId" :rules="disabled ? {} : _required('请选择')">
        <select-tree
          v-model="formData.tenantId"
          type="5"
          url="/buz/merchant/read/tree"
          :params="{ nodeType: 0 }"
          :isAll="true"
          disabled
          immediate
          :clearable="false"
          ref="selectTree"
        />
      </FormItem>
      <FormItem v-if="!id || (id && formData.tenantId === userInfo.tenantId)" label="申请人" prop="agentId" :rules="disabled ? {} : _required('请选择')">
        <Select v-model="formData.agentId" :disabled="disabled" clearable filterable>
          <Option v-for="item in userList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem label="预约状态">
        <span class="my-tag" v-if="formData.status == 0">待完善</span>
        <span class="my-tag org" v-if="formData.status == 1">预约中</span>
        <span class="my-tag green" v-if="formData.status == 2">预约成功</span>
        <span class="my-tag blue" v-if="formData.status == 3">已签单</span>
        <span class="my-tag" v-if="formData.status == -1">取消预约</span>
      </FormItem>
      <FormItem label="银行开户服务状态" v-if="formData.svcOrder.id">
        <span class="my-tag" v-if="formData.svcOrder.orderState == 1">待审核</span>
        <span class="my-tag green" v-if="formData.svcOrder.orderState == 2">可开户</span>
        <span class="my-tag red" v-if="[3, 4].includes(formData.svcOrder.orderState * 1)">无法开户</span>
      </FormItem>
      <template v-if="!id">
        <FormItem label="预约表格加载">
          <Upload
            ref="upload"
            :show-upload-list="false"
            accept=".xlsx,.xls"
            :on-success="handleSuccess"
            :before-upload="handleBeforeUpload"
            multiple
            action="/buz/reservation/import"
          >
            <Button icon="md-cloud-upload">上传</Button>
          </Upload>
        </FormItem>
        <FormItem label="预约模板">
          <Button icon="md-cloud-download" @click="downloadTemplateFile()">下载</Button>
        </FormItem>
      </template>
      <FormItem label="签约保单号" v-if="formData.policyNo">
        <span class="table-btn descrypt-text" @click="goPolicy">{{ formData.policyNo }}</span>
        <a v-if="disabled && formData.policyNo" style="position: absolute; color: #2d8cf0 !important">
          <i class="iconfont iconyincang eye-icon eye" v-if="!formData.eyeShowpolicyNo" @click="openEye(formData, 'policyNo')"></i>
        </a>
      </FormItem>
      <FormItem label="客户是否转介" prop="isReferral">
        <span>{{ allData.isReferral | filterYesOrNo }}</span>
      </FormItem>
      <FormItem v-if="allData.isReferral == 1" label="客户转介人" prop="referralName">
        <span>{{ allData.referralName }}</span>
      </FormItem>
      <template v-if="formData.status == 2 || formData.status == 3">
        <div class="form-title">行程信息</div>
        <FormItem v-if="tripInfo.TRname && tripInfo.TRmobile" label="業務代表"> {{ tripInfo.TRname }} {{ tripInfo.TRmobile }} </FormItem>
        <FormItem label="具体签单地点">
          {{ tripInfo.signAddrFull }}
        </FormItem>
      </template>

      <div class="form-title">基本计划</div>
      <FormItem label="签单地点" prop="signAddr" :rules="disabled ? {} : _required('请输入')">
        <lzDicTxt v-if="disabled" :dicCode="formData.signAddr" dicType="SIGNING_CITY"></lzDicTxt>
        <lzDicSelect v-else v-model="formData.signAddr" dicType="SIGNING_CITY"> </lzDicSelect>
      </FormItem>
      <FormItem label="保险公司" prop="companyId" :rules="disabled ? {} : _required('请选择')">
        <span v-if="disabled">{{ formData.companyId | filterVal(companyList, 'id', 'name') }}</span>
        <Select v-else v-model="formData.companyId" clearable filterable @on-change="companyChange()">
          <Option v-for="(item, index) in companyList" :value="item.id" :key="index">{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem label="产品名称" prop="productId" :rules="disabled ? {} : _required('请选择')">
        <span v-if="disabled">{{ formData.productId | filterVal(searchProductList, 'productId', 'productName') }}</span>
        <Select v-else v-model="formData.productId" clearable filterable @on-select="productChange">
          <Option v-for="item in searchProductList" :value="item.productId" :key="item.productId" :label="item.productName">
            <Tag v-if="item.status == 0" color="success">在售</Tag>
            <Tag v-else color="default">停售</Tag>
            <span class="product-name-text">{{ item.productName }}</span></Option
          >
        </Select>
      </FormItem>
      <FormItem label="缴费期" prop="paymentPeriod" :rules="paymentPeriodRules">
        <span v-if="disabled">{{ formData.paymentPeriod }}</span>
        <Input v-else v-model="formData.paymentPeriod" placeholder="请输入" @on-blur="onNumberInput('paymentPeriod')"> </Input>
      </FormItem>
      <FormItem label="缴费类型" prop="paymentType" :rules="disabled ? {} : $units.formRule.required('请选择')">
        <lzDicTxt v-if="disabled" dicType="GUARANTEE_TYPE" :dicCode="formData.paymentType"></lzDicTxt>
        <lzDicSelect v-else v-model="formData.paymentType" dicType="GUARANTEE_TYPE" :transfer="true" clearable placeholder="请选择"> </lzDicSelect>
      </FormItem>
      <FormItem label="保障期" prop="guaranteePeriod" :rules="guaranteePeriodRules">
        <span v-if="disabled">{{ formData.guaranteePeriod }}</span>
        <Input v-else v-model="formData.guaranteePeriod" placeholder="请输入" @on-blur="onNumberInput('guaranteePeriod')"> </Input>
      </FormItem>
      <FormItem label="保障类型" prop="guaranteeType" :rules="disabled ? {} : $units.formRule.required('请选择')">
        <lzDicTxt v-if="disabled" dicType="GUARANTEE_TYPE" :dicCode="formData.guaranteeType"></lzDicTxt>
        <lzDicSelect v-else v-model="formData.guaranteeType" dicType="GUARANTEE_TYPE" :transfer="true" clearable placeholder="请选择"> </lzDicSelect>
      </FormItem>
      <FormItem label="年缴保费（仅数字）" prop="fee" :rules="disabled ? {} : _num()" :label-width="140">
        <span v-if="disabled">{{ formData.fee }}</span>
        <Input v-else v-model="formData.fee" placeholder="只能填写数字" />
      </FormItem>
      <FormItem label="货币种类" prop="currencyType" :rules="disabled ? {} : _required('请选择')">
        <lzDicTxt v-if="disabled" :dicCode="formData.currencyType" dicType="CURRENCY_INT"></lzDicTxt>
        <lzDicSelect v-else v-model="formData.currencyType" dicType="CURRENCY_INT" :transfer="true" clearable> </lzDicSelect>
      </FormItem>
      <FormItem label="保险额度（重疾）" prop="coverage" :rules="disabled ? {} : _num('输入的类型为数字', false)">
        <span v-if="disabled">{{ formData.coverage }}</span>
        <Input v-else v-model="formData.coverage" placeholder="只能填写数字" />
      </FormItem>
      <FormItem label="首期付款方式" prop="initialPaymentWay" :rules="disabled ? {} : _required('请选择')">
        <lzDicTxt v-if="disabled" :dicCode="formData.initialPaymentWay" dicType="FIRST_PAY_TYPE"></lzDicTxt>
        <lzDicSelect v-else v-model="formData.initialPaymentWay" dicType="FIRST_PAY_TYPE" :transfer="true" clearable> </lzDicSelect>
      </FormItem>
      <FormItem label="预约签单日期" prop="appointSignDate" :rules="disabled ? {} : _required('请选择')">
        <span v-if="disabled">{{ formData.appointSignDate }}</span>
        <DatePicker
          v-else
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          placeholder="选择日期"
          :editable="false"
          :value="formData.appointSignDate"
          @on-change="$set(formData, 'appointSignDate', $event)"
        ></DatePicker>
      </FormItem>
      <FormItem label="是否追溯">
        <span v-if="disabled">{{ formData.isDateBack | filterYesOrNo }}</span>
        <Select v-else v-model="formData.isDateBack" clearable>
          <Option value="1">是</Option>
          <Option value="0">否</Option>
        </Select>
      </FormItem>
      <FormItem label="是否预缴" prop="isPrePay" :rules="disabled ? {} : _required('请选择是否预缴')">
        <span v-if="disabled">{{ formData.isPrePay | filterYesOrNo }}</span>
        <RadioGroup v-else v-model="formData.isPrePay">
          <Radio label="1">是</Radio>
          <Radio label="0">否</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem v-if="disabled && formData.isPrePay == 1 && allData.prepaidYears !== ''" label="预缴保费年限" prop="prepaidYears">
        <span>{{ allData.prepaidYears | filterPrepaidYears }}</span>
      </FormItem>
      <FormItem label="是否预约开户" prop="isPreAccount" :rules="disabled || disabledBank ? {} : _required('请选择是否预约开户')">
        <span v-if="disabled || disabledBank">{{ formData.isPreAccount | filterYesOrNo }}</span>
        <RadioGroup v-else v-model="formData.isPreAccount">
          <Radio label="1">是</Radio>
          <Radio label="0">否</Radio>
        </RadioGroup>
      </FormItem>
      <template v-if="formData.isPreAccount == 1">
        <FormItem label="开户银行" prop="svcOrder.svcId" :rules="disabled || disabledBank ? { required: false } : _required('请选择开户银行')">
          <div v-if="disabled || disabledBank">{{ formData.svcOrder.svcName }}</div>
          <Select v-else v-model="formData.svcOrder.svcId" clearable filterable @on-select="onSvcIdChange">
            <Option v-for="(item, index) in bankList" :value="item.id" :key="index">{{ item.svcNameAlias }}</Option>
          </Select>
          <span v-if="formData.svcOrder.commission">兑换积分：{{ formData.svcOrder.commission }}</span>
        </FormItem>
        <FormItem
          label="预计可开户日期"
          prop="svcOrder.expectedBankDate"
          :rules="disabled || disabledBank ? { required: false } : _required('请选择预计可开户日期')"
        >
          <span v-if="disabled || disabledBank">{{ formData.svcOrder.expectedBankDate }}</span>
          <DatePicker
            v-else
            type="date"
            format="yyyy-MM-dd"
            placeholder="选择日期"
            :editable="false"
            :value="formData.svcOrder.expectedBankDate"
            @on-change="$set(formData.svcOrder, 'expectedBankDate', $event)"
          ></DatePicker>
        </FormItem>
      </template>

      <FormItem v-if="this.id && disabled" :label-width="130" label="是否为专业投资者" prop="isInvestor">
        <span>{{ allData.isInvestor | filterYesOrNo }}</span>
      </FormItem>

      <template v-if="!this.id || $units.isSelfOrg(formData)">
        <div class="form-title">投保人资料</div>
        <userInfoForm :formData="formData" code="insurant" :disabled="disabled" :feeCheck="feeCheck"></userInfoForm>
        <div class="form-title level2">已生效仍在缴费期的保单情况</div>
        <FormItem label="保险公司">
          <span v-if="disabled">{{ formData.insurant.effectivePolicy.insuranceCompany }}</span>
          <Input v-else v-model="formData.insurant.effectivePolicy.insuranceCompany" placeholder="请输入" />
        </FormItem>
        <FormItem label="保险种类">
          <span v-if="disabled">{{ formData.insurant.effectivePolicy.insuranceType }}</span>
          <Input v-else v-model="formData.insurant.effectivePolicy.insuranceType" placeholder="请输入" />
        </FormItem>
        <FormItem label="保单货币">
          <span v-if="disabled">{{ formData.insurant.effectivePolicy.currency }}</span>
          <Input v-else v-model="formData.insurant.effectivePolicy.currency" placeholder="请输入" />
        </FormItem>
        <FormItem label="年缴保费（分红）" prop="insurant.effectivePolicy.premium" :rules="disabled ? {} : _num('输入的类型为数字', false)">
          <span v-if="disabled">{{ formData.insurant.effectivePolicy.premium }}</span>
          <Input v-else v-model="formData.insurant.effectivePolicy.premium" placeholder="只能填写数字" />
        </FormItem>
        <FormItem label="保额（重疾险）" prop="insurant.effectivePolicy.insuranceCoverage" :rules="disabled ? {} : _num('输入的类型为数字', false)">
          <span v-if="disabled">{{ formData.insurant.effectivePolicy.insuranceCoverage }}</span>
          <Input v-else v-model="formData.insurant.effectivePolicy.insuranceCoverage" placeholder="只能填写数字" />
        </FormItem>
        <FormItem label="投保日期">
          <span v-if="disabled">{{ formData.insurant.effectivePolicy.insuranceDate }}</span>
          <DatePicker
            v-else
            type="date"
            format="yyyy-MM-dd"
            placeholder="选择日期"
            :editable="false"
            :value="formData.insurant.effectivePolicy.insuranceDate"
            @on-change="$set(formData.insurant.effectivePolicy, 'insuranceDate', $event)"
          ></DatePicker>
        </FormItem>
        <FormItem label="剩余缴费年限" prop="insurant.effectivePolicy.remainingPaymentYears" :rules="disabled ? {} : _num('输入的类型为数字', false)">
          <span v-if="disabled">{{ formData.insurant.effectivePolicy.remainingPaymentYears }}</span>
          <Input v-else v-model="formData.insurant.effectivePolicy.remainingPaymentYears" placeholder="只能填写数字" />
        </FormItem>

        <div class="form-title">受保人资料</div>
        <FormItem label="与投保人关系" prop="insured.personalInfo.relation" :rules="disabled ? {} : _required('请选择')">
          <lzDicTxt v-if="disabled" :dicCode="formData.insured.personalInfo.relation" dicType="RELATION_INSURED"></lzDicTxt>
          <lzDicSelect v-else v-model="formData.insured.personalInfo.relation" dicType="RELATION_INSURED" :transfer="true" clearable @change="relationChange">
          </lzDicSelect>
          <div class="info-text" v-if="formData.insured.personalInfo.relation != 'SELF'">受保人与投保人关系为本人时，以下受保人资料信息无需填写</div>
        </FormItem>
        <userInfoForm v-if="formData.insured.personalInfo.relation != 'SELF'" :formData="formData" code="insured" :disabled="disabled"></userInfoForm>
        <div class="form-title">受益人</div>
        <div class="form-title level2">
          <span>受益人信息</span>
          <span class="form-title-info">所有隔代投保的受益人一栏无需填写，默认法定</span>
        </div>
        <FormItem label="受益人类型" class="full">
          <span v-if="disabled">{{ formData.beneficiaryType | filterBeneficiaryType }}</span>
          <RadioGroup v-else v-model="formData.beneficiaryType">
            <Radio label="1" :disabled="beneficiariesDisabled">法定受益人</Radio>
            <Radio label="2" :disabled="beneficiariesDisabled">指定受益人</Radio>
          </RadioGroup>
          <Button type="primary" ghost @click="addBeneficiaries" style="margin-left: 20px" v-if="!disabled && formData.beneficiaryType == 2">
            添加受益人
          </Button>
        </FormItem>
        <template v-if="formData.beneficiaryType == 2">
          <div v-for="(bean, i) in formData.beneficiaries" :key="'beneficiaries' + i">
            <div class="form-title level2">
              受益人{{ i + 1 }}
              <Button type="primary" ghost @click="delBeneficiaries(i)" style="margin-left: 20px" v-if="formData.beneficiaries.length > 1"> 删除 </Button>
            </div>
            <FormItem label="与受保人关系" :prop="`beneficiaries.${i}.relation`" :rules="disabled ? {} : _required('请选择')">
              <lzDicTxt v-if="disabled" :dicCode="bean.relation" dicType="RELATION_BENEFICARY"></lzDicTxt>
              <lzDicSelect v-else v-model="bean.relation" dicType="RELATION_BENEFICARY" :transfer="true" clearable> </lzDicSelect>
            </FormItem>
            <FormItem label="姓名（中文）" :prop="`beneficiaries.${i}.nameZh`" :rules="disabled ? {} : _required('请输入')">
              <span class="descrypt-text" v-if="disabled" @dblclick="openEye(bean, 'nameZh', 'beneficiaries', i)">{{ bean.nameZh }}</span>
              <Input v-else v-model="bean.nameZh" placeholder="请输入" @on-change="beneficiariesNameChange(bean)" />
              <a v-if="disabled && bean.nameZh" style="color: #2d8cf0 !important">
                <i class="iconfont iconyincang eye-icon eye" v-if="!bean.eyeShownameZh" @click="openEye(bean, 'nameZh', 'beneficiaries', i)"></i>
              </a>
            </FormItem>
            <FormItem label="姓名（拼音）" :prop="`beneficiaries.${i}.namePinyin`" :rules="disabled ? {} : _required('请输入')">
              <span class="descrypt-text" v-if="disabled" @dblclick="openEye(bean, 'namePinyin', 'beneficiaries', i)">{{ bean.namePinyin }}</span>
              <Input v-else v-model="bean.namePinyin" placeholder="请输入" />
              <a v-if="disabled && bean.namePinyin" style="color: #2d8cf0 !important">
                <i class="iconfont iconyincang eye-icon eye" v-if="!bean.eyeShownamePinyin" @click="openEye(bean, 'namePinyin', 'beneficiaries', i)"></i>
              </a>
            </FormItem>
            <FormItem label="身份证号码" :prop="`beneficiaries.${i}.idcardNo`" :rules="disabled ? {} : _required('请输入')">
              <span class="descrypt-text" v-if="disabled" @dblclick="openEye(bean, 'idcardNo', 'beneficiaries', i)">{{ bean.idcardNo }}</span>
              <Input v-else v-model="bean.idcardNo" placeholder="请输入" @on-change="idcardChange(bean)">
                <!-- ocr识别按钮 -->
                <idcardOcr slot="suffix" class="ocr-btn" v-if="!disabled" @ok="saveIdcardInfo(bean, $event)" />
              </Input>
              <a v-if="disabled && bean.idcardNo" style="color: #2d8cf0 !important">
                <i class="iconfont iconyincang eye-icon eye" v-if="!bean.eyeShowidcardNo" @click="openEye(bean, 'idcardNo', 'beneficiaries', i)"></i>
              </a>
            </FormItem>
            <FormItem label="性別" :prop="`beneficiaries.${i}.gender`" :rules="disabled ? {} : getGenderRule(bean)">
              <span v-if="disabled">{{ bean.gender | filterSex }}</span>
              <RadioGroup v-else v-model="bean.gender">
                <Radio label="1">男</Radio>
                <Radio label="2">女</Radio>
              </RadioGroup>
            </FormItem>
            <FormItem label="受益比例（%）" :prop="`beneficiaries.${i}.ratio`" :rules="disabled ? {} : _num100()">
              <span v-if="disabled">{{ bean.ratio }}</span>
              <Input v-else v-model="bean.ratio" placeholder="请输入" />
            </FormItem>
          </div>
        </template>

        <div class="form-title">证件信息及资料</div>
        <div class="form-title level2">投保人证件</div>
        <FormItem label="身份证头像面">
          <maskUploadNew v-model="formData.idcardHead1" @show="openEye(formData, 'idcardHead1', 'insurant')" :disabled="disabled" />
        </FormItem>
        <FormItem label="身份证国徽面" :label-width="160">
          <maskUploadNew v-model="formData.idcardBack1" @show="openEye(formData, 'idcardBack1', 'insurant')" :disabled="disabled" />
        </FormItem>
        <FormItem label="港澳通行证/护照头像面" :label-width="160">
          <maskUploadNew v-model="formData.passportHead1" @show="openEye(formData, 'passportHead1', 'insurant')" :disabled="disabled" />
        </FormItem>
        <FormItem label="港澳通行证反面">
          <maskUploadNew v-model="formData.passportBack1" @show="openEye(formData, 'passportBack1', 'insurant')" :disabled="disabled" />
        </FormItem>
        <template v-if="formData.insured.personalInfo.relation != 'SELF'">
          <div class="form-title level2">受保人证件</div>
          <FormItem label="身份证头像面">
            <maskUploadNew v-model="formData.idcardHead2" @show="openEye(formData, 'idcardHead2', 'insured')" :disabled="disabled" />
          </FormItem>
          <FormItem label="身份证国徽面" :label-width="160">
            <maskUploadNew v-model="formData.idcardBack2" @show="openEye(formData, 'idcardBack2', 'insured')" :disabled="disabled" />
          </FormItem>
          <FormItem label="港澳通行证/护照头像面" :label-width="160">
            <maskUploadNew v-model="formData.passportHead2" @show="openEye(formData, 'passportHead2', 'insured')" :disabled="disabled" />
          </FormItem>
          <FormItem label="港澳通行证反面">
            <maskUploadNew v-model="formData.passportBack2" @show="openEye(formData, 'passportBack2', 'insured')" :disabled="disabled" />
          </FormItem>
          <!-- 投保关系为孙子女 -->
          <FormItem label="出生证明/户口本照片" :label-width="160" v-if="formData.insured.personalInfo.relation == 'GRANC'">
            <maskUploadNew v-model="formData.householdRegister2" @show="openEye(formData, 'householdRegister2', 'insured')" :disabled="disabled" />
          </FormItem>
          <!-- 投保关系为配偶 -->
          <FormItem label="结婚证" :label-width="160" v-if="formData.insured.personalInfo.relation == 'COUP'">
            <maskUploadNew v-model="formData.marriageCertificate2" @show="openEye(formData, 'marriageCertificate2', 'insured')" :disabled="disabled" />
          </FormItem>
        </template>

        <div class="form-title level2">其他资料</div>
        <FormItem label="其他资料" class="full">
          <maskUploadNew
            v-model="formData.other"
            :muti="true"
            fileType="pdf,img"
            @show="openEye(formData, 'other', 'other')"
            :disabled="disabled"
            tip="支持上传图片或PDF格式的资料，如户口本、出生证明等"
          />
        </FormItem>
      </template>
    </Form>
    <div class="bottom-btn">
      <Button type="primary" ghost @click="backPage()">返回</Button>
      <template v-if="canEdit">
        <Button type="primary" ghost @click="ok('save')" v-if="formData.status == 0">暂存</Button>
        <Button type="primary" @click="ok('submit')" v-if="formData.status == 0">提交预约</Button>
        <Button type="primary" @click="jumpTrip()" v-if="formData.status == 2">下载行程单</Button>
      </template>
    </div>
    <validUserName ref="validUserNameRef" @success="(...params) => openEye(...params)" />
  </div>
</template>

<script>
import _ from 'lodash';
import { common } from '@/api/mixins';
import lzSelect from '@/components/commons/lzSelect';
import lzDicTxt from '@/components/commons/lzDicTxt';
import lzDicSelect from '@/components/commons/lzDicSelect';
import userInfoForm from './components/userInfoForm';
import maskUploadNew from '@/components/commons/maskUploadNew';
import selectTree from '@/components/system/selectTree3';
import validUserName from '@/components/commons/validUserName';
import idcardOcr from '@/components/commons/idcardOcr';
import Decimal from 'decimal.js';
import pinyin from 'js-pinyin';

const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}') || {};
const dic = JSON.parse(localStorage.dic);
const guaranteeTypeDic = dic['GUARANTEE_TYPE'];

export default {
  mixins: [common],
  components: {
    maskUploadNew,
    idcardOcr,
    userInfoForm,
    selectTree,
    lzSelect,
    lzDicSelect,
    lzDicTxt,
    validUserName
  },
  props: {},
  data() {
    return {
      userInfo,
      allData: '',
      needCheckFee: true, //是否需要保费校验
      isInit: false, // 是否初始化
      attachment: {}, // 附件
      tripInfo: {}, // 行程信息
      userList: [],
      id: '', // ID
      formData: null, // 表单数据
      searchProductList: [], // 产品
      companyList: [], // 保司
      bankList: [], // 开户银行
      loading: false, // 加载状态
      disabledBank: false, // 是否禁用预约开户相关信息
      disabled: false, // 是否禁用编辑
      defAgentList: [],
      canEdit: false // 默认代理人列表
    };
  },
  filters: {
    filterPrepaidYears(val) {
      if (val === '0') {
        return '一笔过';
      } else if (!!val) {
        return '预缴' + val + '年';
      } else {
        return '';
      }
    }
  },
  watch: {
    'formData.guaranteeType'(newVal) {
      if (newVal == '4') {
        this.$set(this.formData, 'guaranteePeriod', '');
      }
    },
    'formData.paymentType'(newVal) {
      if (newVal == '4') {
        this.$set(this.formData, 'paymentPeriod', '');
      }
    }
  },
  computed: {
    paymentPeriodUnit() {
      return guaranteeTypeDic[this.formData.paymentType] || '';
    },
    guaranteePeriodUnit() {
      return guaranteeTypeDic[this.formData.guaranteeType] || '';
    },
    paymentPeriodRules() {
      if (this.disabled) return {};
      return {
        validator: (rule, value, callback) => {
          if (value !== '' && value !== null && value !== undefined) {
            const num = Number(value);
            if (isNaN(num) || num <= 0) {
              callback(new Error('缴费期必须为大于0的数字'));
            } else {
              callback();
            }
          } else {
            callback();
          }
        },
        trigger: 'blur'
      };
    },
    guaranteePeriodRules() {
      if (this.disabled) return {};
      return {
        validator: (rule, value, callback) => {
          if (value !== '' && value !== null && value !== undefined) {
            const num = Number(value);
            if (isNaN(num) || num <= 0) {
              callback(new Error('保障期必须为大于0的数字'));
            } else {
              callback();
            }
          } else {
            callback();
          }
        },
        trigger: 'blur'
      };
    },
    isIFA() {
      return this.userInfo.isIFA;
    },
    // 隔代投保禁用受益人类型，且只能法定
    beneficiariesDisabled() {
      const relation = this.formData.insured.personalInfo.relation;
      if (relation == 'GRANC') {
        this.$set(this.formData, 'beneficiaryType', '1');
        return true;
      }
      return false;
    },
    // 受保人年龄
    insuredAge() {
      const data = this.formData;
      if (!data || !data.insured || !data.insured.personalInfo) {
        return 0;
      }
      let key = 'insured';
      // 如果是本人，数据源为投保人
      if (data.insured.personalInfo.relation == 'SELF') {
        key = 'insurant';
      }
      let birthday = data[key].personalInfo.birthday;
      if (birthday) {
        return this.$units.getAge(birthday);
      } else {
        return 0;
      }
    },
    // 年缴保费不可超过年净收入的40%
    feeCheck() {
      const formData = this.formData;
      // 年缴保费转换为港币
      const rateMap = {
        '1': 1,
        '2': 7.8,
        '3': 1.2
      };
      const rate = rateMap[formData.currencyType] || 1; // 货币转为港币的汇率
      const fee = new Decimal(formData.fee || 0).mul(rate);
      const financeInfo = formData.insurant.financeInfo;
      if (
        fee.toNumber() >=
        new Decimal(financeInfo.monthlyIncome || 0)
          .sub(financeInfo.monthlyExpense || 0)
          .mul(12)
          .mul(0.4)
          .toNumber()
      ) {
        return false;
      }
      return true;
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.useData = this.$route.query.useData;
    this.canEdit = this.$route.query.canEdit === '1';
    this.needCheckFee = true;
    if (this.id) {
      this.getDetail();
      this.setPageTitle('预约详情');
    } else {
      this.setPageTitle('新增预约');
      this.isInit = true;
      this.formData = {
        status: 0,
        agentId: '',
        tenantId: JSON.parse(localStorage.getItem('userInfo') || '{}').tenantId || '',
        svcOrder: {},
        signAddr: 'Hong Kong',
        currencyType: '2',
        isPrePay: '0',
        isPreAccount: '0',
        paymentPeriod: '',
        guaranteeType: '',
        guaranteePeriod: '',
        paymentType: '',
        insurant: {
          // 投保人
          personalInfo: {
            nationality: '1',
            smokingStatus: '0',
            eduLevel: '4'
          }, // 个人资料
          workInfo: {}, // 工作信息
          financeInfo: {}, // 财务信息
          healthInfo: {}, // 健康信息
          effectivePolicy: {} // 已生效仍在缴费期的保单信息
        },
        insured: {
          // 受保人
          personalInfo: {
            cardType: '1',
            nationality: '1',
            eduLevel: '4',
            smokingStatus: '0'
          }, // 个人资料
          workInfo: {}, // 工作信息
          financeInfo: {}, // 财务信息
          healthInfo: {} // 健康信息
        },
        beneficiaryType: '1', // 1-法定 2-指定
        beneficiaries: [{}],
        secondHolder: {}, //保单第二持有人资料
        other: [], //其他附件
        // 投保人
        idcardHead1: [], //身份证头像
        idcardBack1: [], //身份证国徽
        passportHead1: [], // 港澳通行证/护照正面
        passportBack1: [], // 港澳通行证/护照反面
        // 受保人
        idcardHead2: [], //身份证头像
        idcardBack2: [], //身份证国徽
        passportHead2: [], // 港澳通行证/护照正面
        passportBack2: [], // 港澳通行证/护照反面
        householdRegister2: [], // 户口本
        marriageCertificate2: [] // 结婚证
      };
      this.getUserList();
      this.$nextTick(() => {
        this.$refs.selectTree.openChange(true);
      });
      // 如果是从导入数据进入
      if (this.useData) {
        this.$nextTick(() => {
          // 从sessionStorage获取导入的预约数据
          const dataStr = sessionStorage.getItem('import_appt_data') || null;
          if (dataStr) {
            const data = JSON.parse(dataStr);
            sessionStorage.removeItem('import_appt_data');
            // 处理导入的数据
            this.detailData(data, 'fromFile');
            setTimeout(() => {
              this.$refs.myForm.validate().then(valid => {
                console.log('valid', valid);
              });
            }, 1e3);
          }
        });
      } else {
        // 不是导入数据则触发公司变更
        this.companyChange();
      }
    }
  },
  activated() {
    this.queryCompanyList();
    this.queryBankList();
  },
  methods: {
    onNumberInput(field) {
      let value = this.formData[field];
      const filtered = String(value)
        .replace(/[^\d]/g, '')
        .replace(/^0+(\d)/, '$1');
      const finalValue = filtered || '';
      if (finalValue !== String(value)) {
        this.$set(this.formData, field, finalValue);
      }
    },
    // 受益人性别规则校验
    getGenderRule(bean) {
      return {
        required: true,
        trigger: 'change',
        validator: (rule, value, callback) => {
          const relation = bean.relation;
          if (!value) {
            callback(new Error('请选择性别'));
          } else if (['SON', 'FATH'].includes(relation) && value != '1') {
            callback(new Error('与受保人关系为父亲/儿子时，性别只能为男性'));
          } else if (['MOTH', 'DAUG'].includes(relation) && value != '2') {
            callback(new Error('与受保人关系为母亲/女儿时，性别只能为女性'));
          } else {
            callback();
          }
        }
      };
    },
    openEye(row, code, customerTypeCode, index = null) {
      console.log(row);
      if (!row['validName' + code]) {
        this.$refs.validUserNameRef.open(row, code, customerTypeCode, index);
        return;
      }
      if (!row['eyeShow' + code]) {
        let cardType = {
          'idcardHead1': 'idcard_head',
          'idcardBack1': 'idcard_back',
          'passportHead1': 'passport_head',
          'passportBack1': 'passport_back',
          'idcardHead2': 'idcard_head',
          'idcardBack2': 'idcard_back',
          'passportHead2': 'passport_head',
          'passportBack2': 'passport_back',
          'householdRegister2': 'household_register',
          'marriageCertificate2': 'marriage_certificate'
        };
        let operationType = {
          // 1-证件号解密  2-手机号解密 3-银行卡号 4-邮箱  5-通讯地址   6-身份证地址 7-居住地地址 8-通行证/护照号码 9-公司/学校名称 10-公司/学校地址
          idcardNo: 1,
          mobile: 2,
          idcardAddr: 6,
          currentAddr: 7,
          postalAddr: 5,
          passportCode: 8,
          company: 9,
          policyNo: 11,
          address: 10,
          nameZh: 12,
          namePinyin: 13
        };
        let customerType = {
          //       用户类型 1-投保人 2-受保人 3-受益人 4-保单第二持有人
          'insurant': '1',
          'insured': '2',
          'beneficiaries': '3',
          'secondHolder': '4',
          'other': '99'
        };
        this.descrypt(
          {
            index: index,
            cardType: cardType[code],
            query: this.formData.reservationId,
            operationType: operationType[code] || 14,
            operationFunction: 14,
            customerType: customerType[customerTypeCode]
          },
          row,
          code
        ).then(() => {
          this.$set(row, 'eyeShow' + code, true);
        });
      }
    },
    _required() {
      if (this.disabled) {
        return null;
      }
      return this.$units.formRule.required.apply(this, arguments);
    },
    _num() {
      if (this.disabled) {
        return null;
      }
      return this.$units.formRule.num.apply(this, arguments);
    },
    _num100() {
      if (this.disabled) {
        return null;
      }
      return this.$units.formRule.num100.apply(this, arguments);
    },
    // ocr 信息回调
    saveIdcardInfo(bean, data) {
      this.$set(bean, 'nameZh', data.name);
      this.$set(bean, 'idcardNo', data.num);
      this.$set(bean, 'gender', data.sex == '男' ? '1' : '2');
      if (data.pinyin) {
        this.$set(bean, 'namePinyin', data.pinyin);
      } else {
        this.onChangeNameZh(bean);
      }
    },
    // 输入受益人姓名时触发
    beneficiariesNameChange(bean) {
      if (this.formData.id) {
        // 编辑预约时只处理拼音转换
        this.onChangeNameZh(bean);
        return;
      }
      // 如果受益人与投保人、受保人姓名一致同步表单信息
      if (this.formData.insurant.personalInfo.nameZh == bean.nameZh) {
        this.syncBeneficiariesInfo(this.formData.insurant.personalInfo, bean);
      } else {
        // 不需同步时转换姓名拼音
        this.onChangeNameZh(bean);
      }
    },
    // 同步受益人信息
    syncBeneficiariesInfo(source, bean) {
      this.$set(bean, 'namePinyin', source.namePinyin);
      this.$set(bean, 'idcardNo', source.idcardNo);
      this.$set(bean, 'gender', source.gender);
    },
    // 切换受保人关系
    relationChange() {
      const relation = this.formData.insured.personalInfo.relation;
      const insurant = this.formData.insurant; //投保人信息
      const insured = this.formData.insured; //受保人信息
      if (['SON', 'DAUG'].includes(relation) && !this.formData.id) {
        // 儿子女儿 且 新增时才同步敏感信息
        this.$set(insured.personalInfo, 'mobile', insurant.personalInfo.mobile); // 联系电话
        this.$set(insured.personalInfo, 'email', insurant.personalInfo.email); // 电子邮箱
        this.$set(insured.personalInfo, 'idcardAddr', insurant.personalInfo.idcardAddr); // 身份证地址
        this.$set(insured.personalInfo, 'currentAddr', insurant.personalInfo.currentAddr); // 现居住地址
        this.$set(insured.personalInfo, 'postalAddr', insurant.personalInfo.postalAddr); // 通讯地址
        this.$set(insured.personalInfo, 'postalCode', insurant.personalInfo.postalCode); // 通讯地址邮递区号
      }
      if (['SON', 'DAUG', 'GRANC'].includes(relation)) {
        // 儿子/女儿/孙子女 默认值处理
        this.$set(insured.personalInfo, 'maritalStatus', '1'); // 婚姻状况默认未婚
        this.$set(insured.personalInfo, 'dependentNum', '0'); // 供养未成年人数默认0
        this.$set(insured.personalInfo, 'eduLevel', '1'); // 教育程度默认小学及以下
        this.$set(insured.workInfo, 'occupation', '1'); // 职业默认学生
        // 财务信息默认0
        this.$set(insured.financeInfo, 'monthlyIncome', '0');
        this.$set(insured.financeInfo, 'monthlyExpense', '0');
        this.$set(insured.financeInfo, 'fixedAssets', '0');
        this.$set(insured.financeInfo, 'currentAssets', '0');
      } else if ('COUP' == relation) {
        // 配偶
        this.$set(insured.personalInfo, 'maritalStatus', '2'); // 婚姻状况默认未婚
      }
    },
    detailData(data, t) {
      this.allData = data;
      if (data.agentId && data.agentName) {
        this.defAgentList = [
          {
            id: data.agentId,
            name: data.agentName
          }
        ];
      }
      this.checkKey(data, ['detail']);
      const detail = data.detail;
      this.checkKey(detail, ['insurant', 'insured', 'secondHolder', 'svcOrder']);
      this.checkKey(detail.insurant, ['personalInfo', 'workInfo', 'financeInfo', 'healthInfo', 'effectivePolicy']);
      this.checkKey(detail.insured, ['personalInfo', 'workInfo', 'financeInfo', 'healthInfo']);
      if (detail.attachment) {
        detail.other = detail.attachment;
      } else {
        detail.other = [];
      }
      if (detail.insurant.attachment) {
        const arr = detail.insurant.attachment;
        detail.idcardHead1 = arr.filter(item => item.type == 'idcard_head');
        detail.idcardBack1 = arr.filter(item => item.type == 'idcard_back');
        detail.passportHead1 = arr.filter(item => item.type == 'passport_head');
        detail.passportBack1 = arr.filter(item => item.type == 'passport_back');
      } else {
        detail.insurant.attachment = [];
        detail.idcardHead1 = [];
        detail.idcardBack1 = [];
        detail.passportHead1 = [];
        detail.passportBack1 = [];
      }
      if (detail.insured.attachment) {
        const arr = detail.insured.attachment;
        detail.idcardHead2 = arr.filter(item => item.type == 'idcard_head');
        detail.idcardBack2 = arr.filter(item => item.type == 'idcard_back');
        detail.passportHead2 = arr.filter(item => item.type == 'passport_head');
        detail.passportBack2 = arr.filter(item => item.type == 'passport_back');
        detail.householdRegister2 = arr.filter(item => item.type == 'household_register');
        detail.marriageCertificate2 = arr.filter(item => item.type == 'marriage_certificate');
      } else {
        detail.insured.attachment = [];
        detail.idcardHead2 = [];
        detail.idcardBack2 = [];
        detail.passportHead2 = [];
        detail.passportBack2 = [];
        detail.householdRegister2 = [];
        detail.marriageCertificate2 = [];
      }
      if (!detail.beneficiaries || detail.beneficiaries.length == 0) {
        detail.beneficiaries = [{}];
      }
      // 需要转为字符串的key
      const toStringKeyList = ['paymentPeriod', 'guaranteeType', 'guaranteePeriod', 'paymentType', 'isPrePay', 'currencyType', 'beneficiaryType'];
      toStringKeyList.forEach(key => {
        if (typeof data[key] == 'number') {
          data[key] = data[key].toString();
        }
      });
      const toStringKeyList2 = ['isPreAccount', 'isDateBack'];
      toStringKeyList2.forEach(key => {
        if (typeof detail[key] == 'number') {
          detail[key] = detail[key].toString();
        }
      });
      // 复制字段
      this.moveKey(data, detail);
      this.formData = detail;
      if (t === 'fromFile') {
        this.$nextTick(() => {
          // 受益人
          if (this.formData.beneficiaries && this.formData.beneficiaries.length) {
            this.formData.beneficiaries.forEach(item => {
              if (typeof item.ratio === 'string') {
                item.ratio = Number(item.ratio);
              }
              this.idcardChange(item);
            });
          }
          // 第二持有人
          if (this.formData.secondHolder) {
            this.idcardChange(this.formData.secondHolder);
          }
          // 投保人
          if (this.formData.insurant.personalInfo) {
            this.idcardChange(this.formData.insurant.personalInfo);
          }
          // 受保人
          if (this.formData.insured.personalInfo) {
            this.idcardChange(this.formData.insured.personalInfo);
          }
        });
        this.companyChange().then(() => {
          setTimeout(() => {
            const hasCompany = this.companyList.some(c => c.id == detail.companyId);
            const msg = [];
            if (!hasCompany) {
              this.formData.companyId = '';
              this.formData.productId = '';
              if (detail.companyName) {
                msg.push(`文档中的保司【${detail.companyName}】在系统中不存在`);
              } else {
                msg.push(`文档中的保司为空`);
              }
            }
            const hasProduct = this.searchProductList.some(p => p.productId == detail.productId);
            if (!hasProduct) {
              this.formData.productId = '';
              if (detail.productName) {
                msg.push(`文档中的产品【${detail.productName}】在系统中不存在`);
              } else {
                msg.push(`文档中的产品为空`);
              }
            }

            if (msg.length) {
              this.$Modal.warning({
                title: '提示',
                content: '<div class="error-msg">' + msg.join('<br/>') + '</div>'
              });
            }
            this.$refs.myForm.validate(null, (valid, a, b) => {
              console.log('valid', valid, a, b);
            });
          }, 500);
        });
      } else {
        this.companyChange();
      }

      if (this.canEdit) {
        if (data.status == 0) {
          this.disabled = false;
        } else {
          this.disabled = true;
        }
      } else {
        this.disabled = true;
      }
      if (data.status == 2 || data.status == 3) {
        this.getTripInfo(data.bizTrip);
      }
      if (data.tenantId) {
        this.getUserList();
      }
      this.$nextTick(() => {
        this.$refs.selectTree.openChange(true);
      });
      this.clearValidate();
      window.setTimeout(() => {
        this.isInit = true;
      }, 1000);
      // 服务订单审核成功禁止修改
      this.disabledBank = detail.svcOrder.orderState == 2 || detail.svcOrder.orderState == 4;
    },
    // 获取详情
    getDetail() {
      this.isInit = false;
      this.$http({
        url: '/buz/reservation/detail',
        type: 'GET',
        data: { id: this.id }
      }).then(res => {
        const data = res.data;
        this.detailData(data);
      });
    },
    // 获取行程信息
    /**
     * 获取行程信息
     * @param {Object} data - 行程数据对象
     * @property {String} data.bizTripUrl - 行程单链接
     * @property {Array} data.holderCerts - 持有人证件信息
     * @property {String} data.gatherDate - 集合日期
     * @property {String} data.signAddrFull - 签单地址
     * @property {String} data.gatherAddrFull - 集合地址
     * @property {Array} data.receptionistInfos - 接待人员信息
     */
    getTripInfo(data) {
      const tripInfo = {
        bizTripUrl: data.bizTripUrl,
        holderCerts: data.holderCerts,
        gatherDate: data.gatherDate,
        signAddrFull: data.signAddrFull,
        gatherAddrFull: data.gatherAddrFull
      };
      data.receptionistInfos &&
        data.receptionistInfos.forEach(item => {
          if (item.type == 'RECEPTION') {
            // 接待人员
            tripInfo.RECEPTIONname = item.name;
            tripInfo.RECEPTIONmobile = item.mobile;
          } else if (item.type == 'TR') {
            // TR人员
            tripInfo.TRname = item.name;
            tripInfo.TRmobile = item.mobile;
          }
        });
      this.tripInfo = tripInfo;
    },
    /**
     * 检测数组，包含对应类型就返回
     * arr 被检测的数组
     * type 需要检测的类型
     */
    checkArr(arr, type) {
      return arr.filter(item => item.type == type);
    },
    /**
     * 检测对象是否包含对应属性，不存在就添加
     * data 被检测的对象
     * keyArr 需要检测的属性数组
     */
    checkKey(data, keyArr) {
      keyArr.forEach(key => {
        if (!data[key]) {
          this.$set(data, key, {});
        }
      });
    },
    checkType(item) {
      return item.split('.').pop().toLowerCase();
    },
    handleBeforeUpload(file) {
      if (!/\.(xlsx?)$/.test(file.name.toLowerCase())) {
        this.$Message.error('上传格式不正确');
        return false;
      }
      if (this.uploadFileMsg) {
        this.uploadFileMsg();
        this.uploadFileMsg = null;
      }
      this.uploadFileMsg = this.$Message.loading({
        content: '正在上传',
        duration: 0
      });
    },
    handleSuccess(res, file) {
      if (this.uploadFileMsg) {
        this.uploadFileMsg();
        this.uploadFileMsg = null;
      }
      if (res.httpCode != 1) {
        let msgStr = res.msg;
        try {
          msgStr = res.msg.split('\n').join('<br/>');
        } catch (e) {}
        this.$Modal.warning({
          title: '提示',
          content: '<div class="error-msg">' + msgStr + '</div>'
        });

        setTimeout(() => {
          this.$refs.myForm.validate().then(valid => {
            console.log('valid', valid);
          });
        }, 1e3);
      } else {
        this.uploadFileMsg = this.$notice.success('上传成功');
        this.detailData(res.data, 'fromFile');
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.myForm.validate().then(valid => {
              console.log('valid', valid);
            });
          }, 1e3);
        });
      }
    },
    downloadTemplateFile() {
      this.$http({
        url: '/buz/reservationTemplate/read/list',
        type: 'POST',
        data: {}
      }).then(res => {
        if (res.httpCode === 1) {
          try {
            const list = JSON.parse(res.data[0].fileJson);
            this.$units.downloadFun({ url: '/upload/downloadByUrl', params: { url: list[0].path } }, '预约模版.xlsx');
          } catch (err) {
            console.error(err);
            this.$Message.error('下载文件失败');
          }
        }
      });
    },
    // 选择保司，查询产品
    companyChange() {
      if (!this.formData.tenantId) {
        this.searchProductList = [];
        return Promise.resolve();
      }
      const params = {
        pageNo: 1,
        pageSize: 999,
        tenantId: this.formData.tenantId
      };
      if (this.formData.companyId) {
        params.companyId = this.formData.companyId;
      }
      return this.$http({
        url: '/buz/merchantProduct/merchant/list',
        type: 'POST',
        data: params
      })
        .then(res => {
          this.searchProductList = res.data;
          return Promise.resolve();
        })
        .catch(() => {
          return Promise.resolve();
        });
    },
    // 选择产品
    productChange(data) {
      const bean = this.searchProductList.find(item => item.productId == data.value);
      if (bean) {
        this.$set(this.formData, 'companyId', bean.companyId);
      }
    },
    // 查询所有保司
    queryCompanyList() {
      this.$http({
        url: '/buz/insuranceCompany/search',
        type: 'POST',
        data: {
          pageNo: 1,
          pageSize: 999
        }
      }).then(res => {
        this.companyList = res.data;
      });
    },
    // 获取开户银行
    queryBankList() {
      this.$http({
        url: '/buz/extSvc/page',
        type: 'POST',
        data: {
          pageNo: 1,
          pageSize: 999,
          status: 1,
          svcCateCode: 'BANK_ACCOUNT'
        }
      }).then(res => {
        this.bankList = res.data;
      });
    },
    // 查询申请人
    getUserList() {
      const params = {
        selectSub: 1,
        // type: 1, // 1-业务员 2-机构管理员 3-商户管理员
        tenantId: this.formData.tenantId
      };
      this.$http({
        url: '/buz/userBase/list',
        type: 'POST',
        data: params
      }).then(res => {
        this.userList = res.data.filter(i => i.ifaType != 2);
      });
    },
    validate(fields, callback) {
      const formFields = this.$refs.myForm.fields;
      const _fields = fields.map(field => formFields.find(item => item.prop == field));
      return new Promise(resolve => {
        let valid = true;
        let count = 0;
        // fields 为空需要返回promise
        if (_fields.length === 0) {
          resolve(valid);
          if (typeof callback === 'function') {
            callback(valid);
          }
        }
        _fields.forEach(field => {
          field &&
            field.validate('', errors => {
              if (errors) {
                valid = false;
              }
              if (++count === _fields.length) {
                // all finish
                resolve(valid);
                if (typeof callback === 'function') {
                  callback(valid);
                }
              }
            });
        });
      });
    },
    ok(type) {
      if (type == 'submit') {
        this.$refs.myForm.validate().then(async isok => {
          if (!isok) {
            this.$notice.error('校验不通过，请完善表单');
            this.$nextTick(() => {
              document.getElementsByClassName('ivu-form-item-error')[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
            return;
          }
          this.okCallback(type, '/buz/reservation/submit');
        });
      } else {
        this.clearValidate();
        window.setTimeout(() => {
          // 必填校验

          const keyArr = this.$units.isSelfOrg(this.formData)
            ? ['tenantId', 'agentId', 'productId', 'insurant.personalInfo.nameZh', 'insurant.personalInfo.mobile']
            : ['tenantId', 'agentId', 'productId'];
          let hasError = false;
          keyArr.forEach(key => {
            this.$refs.myForm.validateField(key, errorMsg => {
              if (errorMsg) {
                hasError = true;
              }
            });
          });
          // 非必填格式校验
          const keyArr2 = ['fee', 'coverage', 'coverage'];
          if (this.$units.isSelfOrg(this.formData)) {
            keyArr2.push(
              'insurant.personalInfo.email',
              'insurant.personalInfo.dependentNum',
              'insurant.personalInfo.postalCode',
              'insurant.healthInfo.weight',
              'insurant.healthInfo.height',
              'insurant.workInfo.postalCode',
              'insurant.financeInfo.monthlyIncome',
              'insurant.financeInfo.monthlyExpense',
              'insurant.financeInfo.fixedAssets',
              'insurant.financeInfo.currentAssets',
              'insurant.effectivePolicy.premium',
              'insurant.effectivePolicy.insuranceCoverage',
              'insurant.effectivePolicy.remainingPaymentYears',
              'insured.personalInfo.mobile',
              'insured.personalInfo.email',
              'insured.personalInfo.dependentNum',
              'insured.personalInfo.postalCode',
              'insured.healthInfo.weight',
              'insured.healthInfo.height',
              'insured.workInfo.postalCode',
              'insured.financeInfo.monthlyIncome',
              'insured.financeInfo.monthlyExpense',
              'insured.financeInfo.fixedAssets',
              'insured.financeInfo.currentAssets'
            );
            // 指定受益人
            if (this.formData.beneficiaryType == 2) {
              keyArr2.push('beneficiaries.0.ratio', 'beneficiaries.1.ratio');
            }
          }
          keyArr2.forEach(key => {
            if (_.get(this.formData, key)) {
              this.$refs.myForm.validateField(key, errorMsg => {
                if (errorMsg) {
                  hasError = true;
                }
              });
            }
          });
          if (hasError) {
            this.$notice.error('校验不通过，请完善表单');
            this.$nextTick(() => {
              document.getElementsByClassName('ivu-form-item-error')[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
            return;
          }
          this.okCallback(type, '/buz/reservation/save');
        }, 100);
      }
    },
    // 提交回调
    okCallback(type, url) {
      const formData = JSON.parse(JSON.stringify(this.formData));
      // 补全时间
      if (formData.appointSignDate && formData.appointSignDate.length == 16) {
        formData.appointSignDate = formData.appointSignDate + ':00';
      }
      const data = {
        detail: formData
      };
      data.mobile = formData.insurant.personalInfo.mobile;
      data.name = formData.insurant.personalInfo.nameZh;
      data.id = formData.reservationId;
      this.moveKey(formData, data);
      // 处理附件
      formData.attachment = [];
      formData.insurant.attachment = [];
      formData.insured.attachment = [];
      console.log('formData', formData);
      this.addKey(formData.insurant.attachment, formData, 'idcardHead1', 'idcard_head');
      this.addKey(formData.insurant.attachment, formData, 'idcardBack1', 'idcard_back');
      this.addKey(formData.insurant.attachment, formData, 'passportHead1', 'passport_head');
      this.addKey(formData.insurant.attachment, formData, 'passportBack1', 'passport_back');
      this.addKey(formData.insured.attachment, formData, 'idcardHead2', 'idcard_head');
      this.addKey(formData.insured.attachment, formData, 'idcardBack2', 'idcard_back');
      this.addKey(formData.insured.attachment, formData, 'passportHead2', 'passport_head');
      this.addKey(formData.insured.attachment, formData, 'passportBack2', 'passport_back');
      this.addKey(formData.insured.attachment, formData, 'householdRegister2', 'household_register');
      this.addKey(formData.insured.attachment, formData, 'marriageCertificate2', 'marriage_certificate');
      this.addKey(formData.attachment, formData, 'other', 'other');
      // 本人投保重置受保人数据
      if (formData.insured.personalInfo.relation == 'SELF') {
        formData.insured = {
          personalInfo: {
            relation: 'SELF'
          }
        };
      }
      if (type == 'submit') {
        // 隔代投保禁用受益人类型，且只能法定
        if (formData.beneficiaryType == 1 || this.beneficiariesDisabled) {
          // 法定受益人
          formData.beneficiaries = [];
        } else if (formData.beneficiaryType == 2) {
          // 指定受益人
          let ratio = 0;
          formData.beneficiaries.forEach(item => {
            ratio = new Decimal(ratio).add(item.ratio).toNumber();
          });
          if (ratio != 100) {
            return this.$notice.error('受益比例总和必须为100%');
          }
        }
        // 受保人大于等于18周岁，不显示保单第二持有人的板块
        if (this.insuredAge >= 18) {
          formData.secondHolder = {};
        }
        // 非预约开户清空开户数据
        if (formData.isPreAccount != 1) {
          formData.svcOrder = {};
        }
        // 年缴保费不可超过年净收入的40%
        if (this.needCheckFee && !this.feeCheck) {
          this.$notice.inquiry('年缴保费需小于投保人年净收入的40%，请确认是否提交？').then(() => {
            this.needCheckFee = false;
            this.okCallback(type, url);
          });
          return;
        }
      }
      if (this.loading) {
        return;
      }
      this.$notice.showLoading();
      this.loading = true;
      this.$http({
        url: url,
        type: 'post',
        data: data
      })
        .then(res => {
          this.needCheckFee = true;
          this.$notice.success(type == 'submit' ? '提交成功' : '保存成功');
          if (!this.formData.id) {
            this.id = res.data;
          }
          this.getDetail();
        })
        .finally(res => {
          this.$notice.hideLoading();
          window.setTimeout(() => {
            this.loading = false;
          }, 300);
        });
    },
    addKey(saveList, data, key, type) {
      data[key].forEach(item => {
        item.type = type;
        saveList.push(item);
      });
      delete data[key];
    },
    // 添加受益人
    addBeneficiaries() {
      this.formData.beneficiaries.push({
        type: '2' // 1-法定 2-指定
      });
    },
    // 删除受益人
    delBeneficiaries(i) {
      this.formData.beneficiaries.splice(i, 1);
    },
    idcardChange(data) {
      const idNo = data.idcardNo;
      const pattern = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (pattern.test(idNo)) {
        const birthday = idNo.substr(6, 4) + '-' + idNo.substr(10, 2) + '-' + idNo.substr(12, 2);
        const sex = idNo.substr(16, 1) % 2 == 1 ? '1' : '2';
        this.$set(data, 'birthday', birthday);
        this.$set(data, 'gender', sex);
      }
    },
    // 返回
    backPage() {
      this.back(this.$route.query.backUrl || '/operate/appointmentManager/index');
    },
    // 下载行程单
    jumpTrip() {
      if (!this.tripInfo.bizTripUrl) {
        this.$notice.error('行程单不存在');
        return;
      }
      this.$units.downloadFun({
        url: this.tripInfo.bizTripUrl
      });
    },
    // 跳转保单详情
    goPolicy() {
      if (!this.formData.policyId) {
        this.$notice.error('policyId不存在');
        return;
      }
      this.openPageTabTags('/operate/orderManage/insuredOrder/policyDetail', {
        backUrl: this.$route.fullPath,
        id: this.formData.policyId,
        reqUrl: 'read/detail'
      });
    },
    // 请选择开户银行
    onSvcIdChange(e) {
      const data = this.bankList.find(item => item.id == e.value);
      if (data) {
        this.$set(this.formData.svcOrder, 'commission', data.commission);
      }
    },
    /**
     * 移动数据
     * @param {Object} getData 获取数据的对象
     * @param {Object} setData 设置数据的对象
     */
    moveKey(getData, setData) {
      const keyList = [
        'reservationNo',
        'status',
        'policyNo',
        'agentId',
        'tenantId',
        'chatRoomId',
        'suppliers',
        'remark',
        'companyId',
        'companyName',
        'productId',
        'productName',
        'paymentPeriod',
        'guaranteeType',
        'guaranteePeriod',
        'paymentType',
        'fee',
        'currencyType',
        'appointSignDate',
        'coverage',
        'beneficiaryType',
        'signAddr',
        'isPrePay'
      ];
      keyList.forEach(key => {
        // 仅当源数据存在时才复制属性，避免覆盖目标对象已有值
        if (Object.prototype.hasOwnProperty.call(getData, key)) {
          setData[key] = getData[key];
        }
      });
    },
    // 转换拼音
    onChangeNameZh(data) {
      const py = pinyin.getFullChars(data.nameZh);
      pinyin.setOptions({
        checkPolyphone: false,
        charCase: 0
      });
      this.$set(data, 'namePinyin', py);
    }
  }
};
</script>
<style lang="scss" scoped>
.info-box {
  background: linear-gradient(106deg, #fff7ea 0%, #fff1e8 100%);
  padding: 12px 24px;
  margin-bottom: 15px;
  color: red;
}
.my-tag {
  margin-top: 3px;
}
.main-container {
  padding-bottom: 100px;
}
.info-text {
  font-size: 12px;
  white-space: nowrap;
  margin-left: -90px;
  color: #236dff;
}
.bottom-btn {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 70px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #ccc;
  .ivu-btn {
    width: 140px;
    height: 35px;
  }
  .ivu-btn + .ivu-btn {
    margin-left: 20px;
  }
}
</style>
